import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function VerifyResetToken() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const token_hash = searchParams.get('token_hash');
        const type = searchParams.get('type');

        if (!token_hash || type !== 'recovery') {
          throw new Error('Invalid or expired reset link');
        }

        const { error, data } = await supabase.auth.verifyOtp({
          token_hash,
          type: 'recovery',
        });

        if (error) throw error;

        // Check if we have a session after verification
        if (!data?.session) {
          throw new Error('Failed to establish session. Please try again.');
        }

        // Redirect to password reset form after successful verification
        navigate('/reset-password/new');

      } catch (err: any) {
        setError(err.message);
        //setTimeout(() => navigate('/'), 5000);
      }
    };

    verifyToken();
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
          <p className="text-center mt-4 text-gray-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
    </div>
  );
}